export default __webpack_public_path__ + "static/media/ch.e6b520ab.svg";